import { useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Typography,
  message,
  Space,
  Radio,
  Divider,
} from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { TextArea } = Input;

export const DynamicRiskAssessmentCreate = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      // Mapping values to API request structure
      // In a full implementation, you'd integrate the 2-tap Risk Matrix component here.
      // For now, we mock the score/level selection.
      const payload = {
        title: values.triggerDescription.substring(0, 50) + "...",
        triggerDescription: values.triggerDescription,
        decision: values.decision,
        additionalControls: values.additionalControls,
        justification: values.justification,
        score: 1, // Mock score
      };
      console.log(payload);

      await new Promise((resolve) => setTimeout(resolve, 500));
      message.success("Dynamic Risk Assessment submitted successfully");
      navigate("/daily-ops/dra");
    } catch (error) {
      message.error("Failed to submit DRA");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <Title level={4}>Create Dynamic Risk Assessment</Title>
      <Text type="secondary">
        Complete this assessment when conditions change dynamically during work.
      </Text>
      <Divider />

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ decision: 1 }}
      >
        <Form.Item
          name="triggerDescription"
          label="What has changed?"
          rules={[
            {
              required: true,
              message: "Please describe what triggered this assessment",
            },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Describe the new hazards or changed conditions..."
          />
        </Form.Item>

        {/* Placeholder for Risk Matrix component integration */}
        <div
          style={{
            marginBottom: 24,
            padding: 16,
            backgroundColor: "#f5f5f5",
            borderRadius: 8,
          }}
        >
          <Text strong>Assess the new Risk (Placeholder)</Text>
          <p style={{ margin: 0, color: "#666" }}>
            Risk Matrix Pad will be displayed here for Likelihood x Consequence
            selection.
          </p>
        </div>

        <Form.Item
          name="decision"
          label="Decision"
          rules={[{ required: true, message: "Please make a decision" }]}
        >
          <Radio.Group style={{ width: "100%" }}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Radio.Button
                value={1}
                style={{
                  width: "100%",
                  textAlign: "center",
                  borderColor: "#52c41a",
                  color: "#52c41a",
                }}
              >
                CONTINUE WORK
              </Radio.Button>
              <Radio.Button
                value={2}
                style={{
                  width: "100%",
                  textAlign: "center",
                  borderColor: "#faad14",
                  color: "#faad14",
                }}
              >
                MODIFY WORK
              </Radio.Button>
              <Radio.Button
                value={3}
                style={{
                  width: "100%",
                  textAlign: "center",
                  borderColor: "#f5222d",
                  color: "#f5222d",
                }}
              >
                STOP WORK
              </Radio.Button>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="additionalControls"
          label="Additional Controls (If modifying work)"
        >
          <TextArea
            rows={3}
            placeholder="What additional controls are needed to proceed safely?"
          />
        </Form.Item>

        <Form.Item name="justification" label="Justification / Notes">
          <TextArea rows={2} />
        </Form.Item>

        <Divider />

        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={() => navigate("/daily-ops/dra")}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
          >
            Submit DRA
          </Button>
        </Space>
      </Form>
    </Card>
  );
};
